// frontend/user/src/components/file-page-segment.tsx
// .pen bi8Au.topRow.segmentedSwitcher(eNmva) — 自适应宽度跟 [TransferButton, NotifBtn] 同行。
// 与 /files?view=<files|shares> URL state 绑定。
// 2026-06-07 文案改版:我的网盘→文件 / 分享→资源包(.pen R8M3h)
import { cn } from '@dogdisk/shared'

type Props = {
  value: 'files' | 'shares'
  onChange: (v: 'files' | 'shares') => void
}

export function FilePageSegment({ value, onChange }: Props) {
  return (
    <div
      data-testid="files-page-segment"
      className="flex h-11 items-center rounded-full bg-[#F6F7F8] p-1 text-[15px]"
    >
      <button
        type="button"
        onClick={() => onChange('files')}
        className={cn(
          'h-9 rounded-full px-6 transition-colors',
          value === 'files'
            ? 'bg-white font-semibold text-[#1A1A1A] shadow-[0_2px_6px_rgba(0,0,0,0.08)]'
            : 'font-medium text-[#9CA3AF]',
        )}
      >
        文件
      </button>
      <button
        type="button"
        onClick={() => onChange('shares')}
        className={cn(
          'h-9 rounded-full px-5 transition-colors',
          value === 'shares'
            ? 'bg-white font-semibold text-[#1A1A1A] shadow-[0_2px_6px_rgba(0,0,0,0.08)]'
            : 'font-medium text-[#9CA3AF]',
        )}
      >
        资源包
      </button>
    </div>
  )
}
